var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.006 0A2 2 0 0 1 16 2.003v8.994c0 1.11-.893 2.003-1.994 2.003h-2.068L9.5 16l-2.438-3H1.994a2 2 0 0 1-1.989-1.853L0 10.997V2.003C0 .893.893 0 1.994 0Z"
})));
export default SvgCommentEmpty;